define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var AccountModel = /** @class */ (function () {
        function AccountModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.CustomerName = ko.observable();
            this.AccountInformation = ko.observable('');
            this.Provider = ko.observable('');
            this.WanInformation = ko.observable('');
            this.MonthlyBill = ko.observable('');
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, AccountModel.Mapping, self);
            }
        }
        AccountModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new AccountModel(options.data);
            }
        };
        return AccountModel;
    }());
    return AccountModel;
});
//# sourceMappingURL=AccountModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/AccountModel.js
// module id = 159
// module chunks = 2